"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pronouns = void 0;
exports.pronouns = ["he", "she", "they"];
